import {
  DELETE_SCHOOL_PERFORMANCE,
  GET_ALL_SCHOOL_PERFORMANCE,
  GET_SCHOOL_PERFORMANCE,
  GET_SCHOOL_PERFORMANCE_BATCH,
  GET_STUDENT_SCHOOL_PERFORMANCE,
} from "../constants/Type";

const initialState = {
  schoolPerformance: null,
  students: null,
  extra: null,
  loading: true,
  results: null,
  all: null,
};

const schoolPerformanceReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_SCHOOL_PERFORMANCE:
      return {
        ...state,
        schoolPerformance: payload.data,
        extra: payload.extra,
        loading: false,
      };
    case GET_ALL_SCHOOL_PERFORMANCE:
      return {
        ...state,
        all: payload.data,
        extra: payload.extra,
        loading: false,
      };
    case GET_SCHOOL_PERFORMANCE_BATCH:
      return {
        ...state,
        results: payload.data,
        extra: payload.extra,
        loading: false,
      };
    case GET_STUDENT_SCHOOL_PERFORMANCE:
      return {
        ...state,
        students: { ...payload.data },
        extra: { ...payload.extra },
        loading: false,
      };
    case DELETE_SCHOOL_PERFORMANCE:
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default schoolPerformanceReducer;
